<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>

import {queryCPSConfig} from "@/api/request";
import EventBus from "@/api/EventBus";
import {webConfig} from "@/api/config";

export default {
  name: 'App',
  data () {
    return {
      isRouterAlive: true
    }
  },
  mounted() {
      document.getElementById('web_title').innerText = webConfig.appName + "CPS";
      document.getElementById('web_logo').href = webConfig.logoUrl;
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    },
  },
  provide () {
    return {
      reload: this.reload
    }
  }
}
</script>

<style>
  body{
    margin: 0;
    padding: 0;
  }
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    color: #2c3e50;
    margin: 0;
    padding: 0;
  }


</style>
